import React, { useEffect, useState } from 'react';
import confetti from 'canvas-confetti';
import { DECORACION } from '../../config/decoracion';
import './SplashMundial.css';

// Paleta celeste y blanco (bandera argentina)
const COLORS = ['#75AADB', '#4A90D9', '#A8D0EF', '#FFFFFF', '#FFFFFF'];

const prefersReduced =
  typeof window !== 'undefined' &&
  window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// Red del arco generada por código (SVG nítido, sin imágenes).
const GoalSVG = () => {
  // Proporción reglamentaria 3:1 (7,32 m x 2,44 m)
  const netV = [];
  for (let x = 32; x < 500; x += 18) netV.push(<line key={`v${x}`} x1={x} y1={25} x2={x} y2={176} />);
  const netH = [];
  for (let y = 36; y < 176; y += 15) netH.push(<line key={`h${y}`} x1={23} y1={y} x2={502} y2={y} />);
  return (
    <svg className="sm-goal" viewBox="0 0 525 185" aria-hidden="true">
      <g className="sm-net" stroke="rgba(255,255,255,0.40)" strokeWidth="1.4">
        {netV}
        {netH}
      </g>
      <g fill="#ffffff">
        <rect x="10" y="12" width="495" height="13" rx="6" />
        <rect x="10" y="12" width="13" height="165" rx="6" />
        <rect x="502" y="12" width="13" height="165" rx="6" />
      </g>
    </svg>
  );
};

const SplashMundial = () => {
  const [show, setShow] = useState(DECORACION === 'mundial' && !prefersReduced);
  const [hiding, setHiding] = useState(false);

  useEffect(() => {
    if (!show) return undefined;
    const timers = [];
    const fire = (opts) => confetti({ disableForReducedMotion: true, zIndex: 1000000, colors: COLORS, ...opts });

    // Explosión principal al "entrar" la pelota + cañones laterales
    timers.push(setTimeout(() => {
      fire({ particleCount: 240, spread: 100, startVelocity: 48, origin: { x: 0.5, y: 0.42 } });
      fire({ particleCount: 110, angle: 60, spread: 80, origin: { x: 0, y: 0.7 } });
      fire({ particleCount: 110, angle: 120, spread: 80, origin: { x: 1, y: 0.7 } });
    }, 1200));
    timers.push(setTimeout(() => {
      fire({ particleCount: 170, spread: 130, startVelocity: 38, origin: { x: 0.5, y: 0.5 } });
    }, 1700));
    timers.push(setTimeout(() => {
      fire({ particleCount: 90, angle: 60, spread: 80, origin: { x: 0, y: 0.7 } });
      fire({ particleCount: 90, angle: 120, spread: 80, origin: { x: 1, y: 0.7 } });
    }, 2100));

    // Fade-out y desmontaje
    timers.push(setTimeout(() => setHiding(true), 2900));
    timers.push(setTimeout(() => setShow(false), 3450));

    return () => timers.forEach(clearTimeout);
  }, [show]);

  if (!show) return null;

  return (
    <div className={`splash-mundial${hiding ? ' is-hiding' : ''}`} role="presentation">
      <div className="sm-stage">
        <GoalSVG />
        <img
          className="sm-ball"
          src={`${process.env.PUBLIC_URL}/img/pelota.png`}
          alt=""
          aria-hidden="true"
        />
        <div className="sm-text">¡GOOOOL!</div>
      </div>
    </div>
  );
};

export default SplashMundial;
